module.exports = __webpack_public_path__ + "static/media/1029628.526ac2a5.jpg";